import './index.css';
import { isNativeApp } from './platform/runtime';

// Native storage must hydrate before importing modules that read auth/player state.
async function bootstrap(): Promise<void> {
  if (isNativeApp()) {
    try {
      const { initializeNativeApp } = await import('./platform/native/bootstrap');
      await initializeNativeApp();
    } catch {
      const { getStartupStage } = await import('./platform/native/startupDiagnostics');
      console.error('[mobile] Initialization failed at stage:', getStartupStage());
      const { showStartupError } = await import('./platform/native/startupError');
      showStartupError();
      return;
    }
  }
  const { installAccountStorageGuard, getPendingAccountCleanup } =
    await import('./platform/accountStorage');
  installAccountStorageGuard(() => window.location.replace('/konto-slettet'));
  if (getPendingAccountCleanup() && window.location.pathname !== '/konto-slettet') {
    window.location.replace('/konto-slettet');
    return;
  }
  await import('./renderApp');
}

void bootstrap();
